import { render, staticRenderFns } from "./LtkItemProduct.vue?vue&type=template&id=77600166&scoped=true"
import script from "./LtkItemProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkItemProduct.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkItemProduct.vue?vue&type=style&index=0&id=77600166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77600166",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandProductProfile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/brand/BrandProductProfile.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,LtkProduct: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkProduct.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default})
